import { render, staticRenderFns } from "./SearchDaquandetails.vue?vue&type=template&id=b2c8e466&scoped=true&"
import script from "./SearchDaquandetails.vue?vue&type=script&lang=js&"
export * from "./SearchDaquandetails.vue?vue&type=script&lang=js&"
import style0 from "./SearchDaquandetails.vue?vue&type=style&index=0&id=b2c8e466&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c8e466",
  null
  
)

export default component.exports